// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"244":"9b1422c7","785":"50c4c235"}[chunkId] + ".chunk.js");